export const flareConfig = {
  key: "973K9oJg6SdilUoojPkMjDKfdDyT0BNo",
};
